import apiCalendarPlan from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  updateCalendarPlanStart:
    '[update competition calendar plan] Update competition calendar plan start',
  updateCalendarPlanSuccess:
    '[update competition calendar plan] Update competition calendar plan success',
  updateCalendarPlanFailure:
    '[update competition calendar plan] Update competition calendar plan failure',

  getCalendarPlanStart:
    '[update competition calendar plan] Get competition calendar plan start',
  getCalendarPlanSuccess:
    '[update competition calendar plan] Get competition calendar plan success',
  getCalendarPlanFailure:
    '[update competition calendar plan] Get competition calendar plan failure',
}

export const actionTypes = {
  updateCalendarPlan:
    '[update competition calendar plan] Update competition calendar plan',
  getCalendarPlan:
    '[update competition calendar plan] Get competition calendar plan',
}

const mutations = {
  [mutationTypes.updateCalendarPlanStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateCalendarPlanSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateCalendarPlanFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getCalendarPlanStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getCalendarPlanSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateCalendarPlan](context, {id, planInput}) {
    context.commit(mutationTypes.updateCalendarPlanStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .updateCompetitionCalendarPlan(id, planInput)
        .then((response) => {
          context.commit(mutationTypes.updateCalendarPlanSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getCalendarPlan](context, {id}) {
    context.commit(mutationTypes.getCalendarPlanStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .competitionCalendarPlan(id)
        .then((response) => {
          context.commit(mutationTypes.getCalendarPlanSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
